/* eslint-disable no-shadow */
/* eslint-disable no-cond-assign */
/* eslint-disable camelcase */
import React, {
  useState, useEffect, useContext, useRef,
} from 'react';
import moment from 'moment';
import { unstable_batchedUpdates } from 'react-dom';
import swal from 'sweetalert';
import SalesManago from '../../pages/InsigthPage/SalesManago';
import salesManagoService from '../../services/salesManagoService';
import { permitsList, swalMessages } from '../../constants';
import { Context } from '../../context/Contex';

const SalesManagoContainer = () => {
  const [value, setValue] = useState(0);
  const [idTag, setIdTag] = useState('');
  const [message, setMessage] = useState('');
  const [sqlQuery, setSqlQuery] = useState('');
  const [field, setField] = useState({});
  const [fields, setFields] = useState({});
  const [con, setCon] = useState(false);
  const [open, setOpen] = useState(false);
  const [isSql, setIsSql] = useState(false);
  const [checked, setCheked] = useState(true);
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);

  const { permisos } = useContext(Context);
  const [prompt, setPrompt] = useState({
    show: false,
    jobId: '',
    archivo: '',
  });
  const [level, setLevel] = useState({ loading: false, level: 0 });
  const [tags, setTags] = useState({ loading: false, tags: [] });
  const [scheme, setScheme] = useState({ loading: false, grupos: [] });

  const timerToClearSomewhere = useRef(null);

  const dataTale = [];

  /*= =======================================================================
 get Tags
======================================================================== */
  const getTags = async () => {
    setTags({ loading: true, tags: [] });
    const tags = await salesManagoService.getTags();
    if (Array.isArray(tags)) {
      try {
        tags.forEach((value) => {
          dataTale.push({
            tag: value.tag,
            cantidad_usuarios: value.cantidad_usuarios,
            creacion: moment(value.creacion).format('ll'),
            estado: value.estado,
            fecha_inicio: moment(value.fecha_inicio).format('ll'),
            fecha_fin: moment(value.fecha_fin).format('ll'),
            usuario_id: value.usuario_id,
            id: value.id,
            sql: value.sql,
            consulta: value.consulta,
          });
        });
      } catch (error) {
        console.log('errorTable', error);
      }

      setTags({
        tags: dataTale,
        loading: false,
      });
    }
  };

  const handleCreateTag = async (newData) => {
    const isCreate = await salesManagoService.createTags(newData);
    if (isCreate) getTags();
  };

  const handleUpdateTag = async (params) => {
    const isUpdate = await salesManagoService.updateTag(params);
    if (isUpdate) getTags();
  };

  const handleDeleteTag = (data) => {
    const tag = tags.tags;
    const newTags = tag.filter((item) => item.id !== data[0].id);
    swal(swalMessages.DELETE_CONFIRM).then(async (willDelete) => {
      if (willDelete) {
        await salesManagoService.deleteTag(data[0].id);
        setTags({ loading: false, tags: newTags });
      }
    });
  };

  /*= =======================================================================
 get getScheme
======================================================================== */
  const getScheme = async () => {
    setScheme({ loading: true, grupos: [] });
    const grupos = await salesManagoService.getScheme();
    if (grupos) {
      setScheme({ loading: false, grupos });
    }
  };

  // Cambio de  chip
  const handleSelectScheme = async (table, group) => {
    const { tabla } = table;
    const { grupo } = group;
    const fields = await salesManagoService.getFields(grupo, tabla, idTag?.id);
    if (fields) {
      setLoading(false);
      setFields(fields);
    }
  };

  // selección en tabla
  const handleSelectRow = (rowSelected) => {
    setFields({});
    tags?.tags.forEach((item, index) => {
      if (rowSelected.id === item.id) {
        setCheked(!checked);
        tags.tags[index].tableData.checked = checked;
      } else {
        tags.tags[index].tableData.checked = false;
      }
      if (rowSelected.sql === '1') {
        setSqlQuery(rowSelected?.consulta);
        setIsSql(true);
      } else {
        setLoading(true);
        setIsSql(false);
      }
    });
    setIdTag(rowSelected);
  };

  const handleChangeGroup = (event, newValue) => {
    setValue(newValue);
    setLoading(true);
  };

  const handleChangeField = async (value, type, field, index) => {
    const old = fields;

    old.campos[index][type] = value;
    delete old.campos[index].individual;

    if (
      (old.campos[index][type] = value) === null
      || (old.campos[index][type] = value) === ''
    ) {
      delete old.campos[index][type];
    }
    if (
      old.campos[index].condicion === undefined
      && type === 'desde'
      && value !== null
    ) {
      old.campos[index].condicion = '=';
    }

    if (old.campos[index].desde?.length > 0 && type === 'hasta') {
      delete old.campos[index].condicion;
    }

    setFields(old);
    setUpdate(true);
    await salesManagoService.putFields({ ...field, [type]: value });
  };

  const handleUpdateFieldIn = (value, array, type2, field, index) => {
    const old = fields;
    delete old.campos[field]?.desde;
    delete old.campos[field]?.hasta;
    delete old.campos[field]?.condicion;

    if (!Array.isArray(old.campos[field][array])) {
      old.campos[field][array] = [];
    }

    if (
      old.campos[field][array].find((element) => element.index === index)
      !== undefined
    ) {
      Object.assign(old.campos[field][array][index], { [type2]: value });
    } else {
      old.campos[field][array].push({ index, [type2]: value });
    }

    if (
      old.campos[field][array][index].condicion === undefined
      && type2 === 'desde'
      && value !== null
    ) {
      Object.assign(old.campos[field][array][index], { condicion: '=' });
    }
    setUpdate(true);
    setFields(old);
  };

  useEffect(() => {
    setUpdate(false);
  }, [update]);

  // ********************************** openModal ******************************************* //

  const handleSelectField = (field, index) => {
    setField(index);
    const old = fields;
    old.campos[index].index = index;
    setFields(old);
    setOpen(true);
  };

  const handleOpenDialog = () => {
    setOpen(!open);
  };

  const handleClearField = (array, field, index) => {
    setUpdate(true);
    const old = fields;
    old.campos[field][array].splice(index, 1);
    if (
      Array.isArray(old.campos[field][array])
      && old.campos[field][array].length === 0
    ) {
      delete old.campos[field][array];
    }
    setFields(old);
    salesManagoService.putFields(old.campos[field]);
  };

  const handleAddField = (array, field, index) => {
    const old = fields;
    if (!Array.isArray(old.campos[field][array])) {
      old.campos[field][array] = [];
    } else {
      old.campos[field][array].splice(index + 1, 0, { index: index + 1 });
    }
    setFields(old);
    setUpdate(!update);
  };

  const handleSaveField = async () => {
    setOpen(!open);
    await salesManagoService.putFields(fields.campos[field]);
  };

  const getConfidenceLevel = async (value) => {
    setLevel({ loading: true });
    let newValue = 0.7;
    if (value >= 0) newValue = value / 100;
    const level = await salesManagoService.getConfidenceLevel(
      idTag?.id,
      newValue,
    );
    unstable_batchedUpdates(() => {
      if (level >= 0) {
        const oldArray = tags;
        const index = tags.tags.findIndex((element) => element.id === idTag.id);
        if (index !== -1) {
          Object.assign(oldArray.tags[index], { cantidad_usuarios: level });
          setTags(oldArray);
        }
        setLevel({ loading: false, level });
      }
    });
  };

  const handleSendSalesManago = async () => {
    setLoadingButton(true);
    const response = await salesManagoService.postSalesManago(idTag?.id);
    if (response) {
      swal(swalMessages.SUCCESSFUL_MESSAGE);
      setLoadingButton(false);
    }
  };

  const handleSQLstatus = (value) => {
    if (value === 0) {
      setIsSql(!isSql);
    }
    if (value === 1) {
      setCon(!con);
    }
  };

  const countSqlConfidenceLevel = async () => {
    setMessage('Conteo de usuarios exitoso');
    setLevel({ loading: true });
    const level = await salesManagoService.countSqlConfidenceLevel(idTag?.id);
    unstable_batchedUpdates(() => {
      if (level >= 0) {
        setLevel({ loading: false, level });
        const oldArray = tags;
        const index = tags.tags.findIndex((element) => element.id === idTag.id);
        if (index !== -1) {
          Object.assign(oldArray.tags[index], { cantidad_usuarios: level });
          setTags(oldArray);
        }
      }
    });
  };

  const handleSaveSqlQuery = async () => {
    const response = await salesManagoService.saveSqlQuery(idTag?.id, sqlQuery);
    if (response) {
      setMessage('Consulta actualizada correctamente');
      setLoading(true);
    }
  };

  const handleChangeSqlQuery = async (event) => {
    setSqlQuery(event.target.value);
  };

  const handleDownloadUsers = async () => {
    const response = await salesManagoService.postUsers(idTag);
    if (response) {
      setPrompt({
        ...response,
        show: true,
      });
    }
    if (!response) {
      setPrompt({
        show: false,
      });
    }
  };

  useEffect(() => {
    getScheme();
    getTags();
    return () => getScheme();
  }, []);

  const handleRequestCSV = async () => {
    const response = await salesManagoService.getCsvUsers(prompt);

    if (response.estado == 'PENDIENTE') {
      setPrompt((prevState) => ({
        ...prevState,
        show: true,
      }));
    }
    if (response.estado == 'FINALIZADO') {
      setPrompt((prevState) => ({
        ...prevState,
        show: false,
      }));
      window.open(response.url);
    }
  };

  const handleSaveCon = async (value) => {
    const response = await salesManagoService.operarTags(value);
    if (response) {
      setSqlQuery(response.query);
      setIsSql(true);
      setCon(!con);
    }
  };

  useEffect(() => {
    if (prompt.show) {
      timerToClearSomewhere.current = setInterval(
        () => handleRequestCSV(),
        2000,
      );
    }
    return () => {
      clearInterval(timerToClearSomewhere.current);
    };
  }, [prompt]);

  return (
    <SalesManago
      con={con}
      idTag={idTag}
      open={open}
      isSql={isSql}
      field={field}
      level={level}
      tags={tags}
      prompt={prompt}
      message={message}
      value={value}
      fields={fields}
      scheme={scheme}
      loading={loading}
      sqlQuery={sqlQuery}
      permisos={permisos}
      permitsList={permitsList}
      addFieldIn={handleAddField}
      onUpdateTag={handleUpdateTag}
      onCreateTag={handleCreateTag}
      onDeleteTag={handleDeleteTag}
      onSelectRow={handleSelectRow}
      onSaveField={handleSaveField}
      loadingButton={loadingButton}
      handleSaveCon={handleSaveCon}
      onClearField={handleClearField}
      onSelectField={handleSelectField}
      onChangeField={handleChangeField}
      onChangeGroup={handleChangeGroup}
      onSelectForm={handleSelectScheme}
      handleOpenDialog={handleOpenDialog}
      onChangeSqlStatus={handleSQLstatus}
      handleDownloadUsers={handleDownloadUsers}
      handleSaveSqlQuery={handleSaveSqlQuery}
      handleChangeSqlQuery={handleChangeSqlQuery}
      handleUpdateFieldIn={handleUpdateFieldIn}
      countSqlConfidenceLevel={countSqlConfidenceLevel}
      onChangeConfidenceLevel={getConfidenceLevel}
      handleSendSalesManago={handleSendSalesManago}
    />
  );
};

export default SalesManagoContainer;
